export default __webpack_public_path__ + "static/media/Bhojpuri_agri3_m.bbbb0029.wav";